import { ASI_SUPPORTED_BLOCK_USE_CASES, BASE_SUPPORTED_BLOCK_USE_CASES, } from '#pplx/frontend/components/utils/consts.js';
export const getSupportedBlockUseCases = ({ isAsiLikeMode, }) => {
    if (isAsiLikeMode)
        return ASI_SUPPORTED_BLOCK_USE_CASES;
    return BASE_SUPPORTED_BLOCK_USE_CASES;
};
//# sourceMappingURL=getSupportedBlockUseCases.js.map